export default{
	DateDiff(date1, date2){ //sDate1和sDate2是2002-12-18格式  
	let s1 = date1.getTime()
	let s2 = date2.getTime()
	let bw = Math.abs(s1-s2)
	return bw  
	} 
}